import { render, staticRenderFns } from "./TreecodeWidget.vue?vue&type=template&id=3c0a6b5d&scoped=true&"
import script from "./TreecodeWidget.vue?vue&type=script&lang=ts&"
export * from "./TreecodeWidget.vue?vue&type=script&lang=ts&"
import style0 from "./TreecodeWidget.vue?vue&type=style&index=0&id=3c0a6b5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0a6b5d",
  null
  
)

export default component.exports